// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"cvs7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>(0, _chunkJWY6Y6NUMjs.render));
parcelHelpers.export(exports, "renderToCanvas", ()=>(0, _chunkJWY6Y6NUMjs.renderToCanvas));
parcelHelpers.export(exports, "parameters", ()=>parameters);
var _chunkJWY6Y6NUMjs = require("./chunk-JWY6Y6NU.mjs");
var parameters = {
    renderer: "react"
};

},{"./chunk-JWY6Y6NU.mjs":"j8dZ1","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"j8dZ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "renderToCanvas", ()=>renderToCanvas);
var _global = require("@storybook/global");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDomShim = require("@storybook/react-dom-shim");
var { FRAMEWORK_OPTIONS } = (0, _global.global), render = (args, context)=>{
    let { id, component: Component } = context;
    if (!Component) throw new Error(`Unable to render story ${id} as the component annotation is missing from the default export`);
    return (0, _reactDefault.default).createElement(Component, {
        ...args
    });
}, ErrorBoundary = class extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        this.state = {
            hasError: !1
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: !0
        };
    }
    componentDidMount() {
        let { hasError } = this.state, { showMain } = this.props;
        hasError || showMain();
    }
    componentDidCatch(err) {
        let { showException } = this.props;
        showException(err);
    }
    render() {
        let { hasError } = this.state, { children } = this.props;
        return hasError ? null : children;
    }
}, Wrapper = FRAMEWORK_OPTIONS?.strictMode ? (0, _react.StrictMode) : (0, _react.Fragment);
async function renderToCanvas({ storyContext, unboundStoryFn, showMain, showException, forceRemount }, canvasElement) {
    let content = (0, _reactDefault.default).createElement(ErrorBoundary, {
        showMain,
        showException
    }, (0, _reactDefault.default).createElement(unboundStoryFn, {
        ...storyContext
    })), element = Wrapper ? (0, _reactDefault.default).createElement(Wrapper, null, content) : content;
    return forceRemount && (0, _reactDomShim.unmountElement)(canvasElement), await (0, _reactDomShim.renderElement)(element, canvasElement), ()=>(0, _reactDomShim.unmountElement)(canvasElement);
}

},{"@storybook/global":"4g4co","react":"jEiK2","@storybook/react-dom-shim":"cN71e","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cN71e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderElement", ()=>renderElement);
parcelHelpers.export(exports, "unmountElement", ()=>unmountElement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var nodes = new Map, WithCallback = ({ callback, children })=>{
    let once = (0, _react.useRef)();
    return (0, _react.useLayoutEffect)(()=>{
        once.current !== callback && (once.current = callback, callback());
    }, [
        callback
    ]), children;
}, renderElement = async (node, el)=>{
    let root = await getReactRoot(el);
    return new Promise((resolve)=>{
        root.render((0, _reactDefault.default).createElement(WithCallback, {
            callback: ()=>resolve(null)
        }, node));
    });
}, unmountElement = (el, shouldUseNewRootApi)=>{
    let root = nodes.get(el);
    root && (root.unmount(), nodes.delete(el));
}, getReactRoot = async (el)=>{
    let root = nodes.get(el);
    return root || (root = (0, _clientDefault.default).createRoot(el), nodes.set(el, root)), root;
};

},{"react":"jEiK2","react-dom/client":"18oA0","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"18oA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_clientJs);
var _clientJs = require("react-dom/client.js");
parcelHelpers.exportAll(_clientJs, exports);

},{"react-dom/client.js":"9MtVF","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9MtVF":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"a0ZmT"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=entry-preview.5a547a6c.js.map
